// Store profile model: mapping and payload builders

export function mapStoreProfileFromApi(item = {}) {
  return {
    id: item.id || item._id || null,
    name: item.name || item.nome || 'Loja sem nome',
    category: item.category || item.categoria || '',
    email: item.email || item.emailComercial || '',
    code: item.code || item.codigo || '',
    about: item.about || item.sobre || '',
    logoKey: item.logoKey || null,

    contact: {
      supportEmail: item.contact?.supportEmail || item.emailSuporte || '',
      phone: item.contact?.phone || item.telefone || '',
      address: {
        cep: item.contact?.address?.cep || '',
        country: item.contact?.address?.country || '',
        state: item.contact?.address?.state || '',
        city: item.contact?.address?.city || '',
        district: item.contact?.address?.district || '',
        street: item.contact?.address?.street || '',
        number: item.contact?.address?.number || '',
        complement: item.contact?.address?.complement || '',
      }
    },

    media: Array.isArray(item.media) ? item.media : [],
  };
}

export function buildUpdateProfilePayload(data) {
  return {
    name: data.name,
    category: data.category,
    email: data.email,
    code: data.code,
    about: data.about,
    logoKey: data.logoKey || null,
    contact: {
      supportEmail: data.contact?.supportEmail || '',
      phone: data.contact?.phone || '',
      address: { ...(data.contact?.address || {}) }
    },
    media: Array.isArray(data.media) ? data.media : []
  };
}

export default { mapStoreProfileFromApi, buildUpdateProfilePayload };
